<template>
  <ul class="slides" :style="{ opacity: opacity }">
    <li v-for="(slide, index) in slides" :key="index" :class="index == current ? 'current' : 'hidden'">
      <Slide :slide="slide" :images="images" />
    </li>
  </ul>
</template>

<script setup>
const props = defineProps({
  slides: { type: Array, default: () => [] },
  images: { type: Array, default: () => [] },
  current: { type: Number, default: 0 },
  opacity: { type: Number, default: 1 },
})
</script>
